const initHeroTicker = () => {
    function setupTicker(tickerEl) {
        const track = tickerEl.querySelector('.ticker__track');
        if (!track) return;

        // Store original once
        if (!track.dataset.originalHtml) {
            track.dataset.originalHtml = track.innerHTML.trim();
        }

        const original = track.dataset.originalHtml;
        if (!original) return;

        // Reset to original before duplicating
        track.innerHTML = original;

        // Duplicate until it overflows enough (for seamless -50% loop)
        const containerWidth = tickerEl.offsetWidth || 1;
        let safety = 0;

        while (track.scrollWidth < containerWidth * 2 && safety < 20) {
            track.insertAdjacentHTML('beforeend', original);
            safety++;
        }

        // Add one more set so -50% always has content
        track.insertAdjacentHTML('beforeend', original);
    }

  function initAll() {
    document.querySelectorAll('.js-ticker').forEach(setupTicker);
  }

  // Debounce resize so we don't rebuild constantly
  let resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  }

  window.addEventListener('load', initAll, { once: true });
  window.addEventListener('resize', onResize);
}

export default initHeroTicker;